import React, { useEffect, useState } from 'react';
import { Col } from 'react-bootstrap';
import { FaCheckCircle, FaExclamationTriangle } from 'react-icons/fa';
import { FaArrowLeft, FaTrash } from 'react-icons/fa6';
import { useParams } from 'react-router-dom';

import {
  fieldObjectRepresentantesOuComunicacoes as fieldObject,
  headersUsuariosVinculados,
} from './auxiliarFornecedores';
import SubAbasFornecedores from './subabasFornecedores';
import BarraInferiorBotoes from '../../../../components/BarraInferiorBotoes';
import BarraSubAbas from '../../../../components/BarraSubAbas';
import BoxConteudo from '../../../../components/BoxConteudo';
import ContainerConteudo from '../../../../components/ContainerConteudo';
import CustomButton from '../../../../components/CustomButton';
import CustomCol from '../../../../components/CustomCol';
import CustomRow from '../../../../components/CustomRow';
import Input from '../../../../components/InputNew';
import Select from '../../../../components/InputNew/Select';
import StyledLink from '../../../../components/Link';
import Log from '../../../../components/Log/Log';
import Modal from '../../../../components/Modal';
import Status from '../../../../components/Status';
import SubAbas from '../../../../components/SubAbas';
import Tabela from '../../../../components/Tabela';
import WorkspaceBotoes from '../../../../components/WorkspaceBotoes';
import WorkspaceBotoesNew from '../../../../components/WorkspaceBotoes/indexNew';
import WorkspaceFicha from '../../../../components/WorkspaceFicha';
import {
  getUser,
  isActionAllowed,
} from '../../../../modules/contexts/Auth/RequireAuth';
import { useCpfValidation } from '../../../../modules/hooks/useCpfValidation';
import { LogData } from '../../../../modules/types/types';
import { useCargoFuncao } from '../../../../services/enum/useCargoFuncao';
import { useGeneros } from '../../../../services/enum/useGeneros';
import { useModuloUsuario } from '../../../../services/enum/useModuloUsuario';
import { usePapelUsuario } from '../../../../services/enum/usePapelUsuario';
import { getFornecedor } from '../../../../services/fornecedoresDAF/fornecedorService';
import { getRepresentantesByFornecedor } from '../../../../services/fornecedoresDAF/representantesService';
import httpClient, { isHttpError } from '../../../../services/httpClient';
import theme from '../../../../theme';
import { ENTITY } from '../../../../utils/entityNames';
import {
  ExportToExcel,
  formataCPF,
  formataNomeMeioSiglas,
  formatDate,
  sanitizarForm,
} from '../../../../utils/functions';
import {
  swal,
  swalAttention,
  swalAtualizacao,
  swalDelete,
  swalDeleteConfirm,
  swalErro,
  swalSave,
} from '../../../../utils/swal';

function FornecedoresPRIndex() {
  //Dados do usuário
  const user = getUser();
  const userID = user.sub;
  const entity = ENTITY.ENTITY_FornecedorRepresentante;

  const [showDetalhesUsuario, setShowDetalhesUsuario] = useState(false);

  const [listaUsuariosEncontrados, setListaUsuariosEncontrados] = useState<
    any[]
  >([]);
  const [usuarioSelecionadoId, setUsuarioSelecionadoId] = useState<
    number | null
  >(null);

  const [usuarioVinculadoSelecionado, setUsuarioVinculadoSelecionado] =
    useState<any>(null);

  const handleRowClickUsuarioVinculado = (payload: any) => {
    const clickedId =
      payload && typeof payload === 'object'
        ? 'id' in payload
          ? (payload as any).id
          : ((payload as any)?.original?.id ??
            (payload as any)?.row?.id ??
            (payload as any)?.values?.id)
        : payload;

    let usuario: any | undefined;

    if (clickedId != null) {
      usuario = usuariosVinculados.find(
        (item) => String(item.id) === String(clickedId),
      );
    }

    if (!usuario && Number.isInteger(clickedId)) {
      usuario = usuariosVinculados[Number(clickedId)];
    }

    if (!usuario) {
      console.warn(
        '[Tabela.onRowClick] Usuário não localizado para payload:',
        payload,
      );
      return;
    }

    setUsuarioVinculadoSelecionado(usuario);
    setShowDetalhesUsuario(true);
  };

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  const [desvinculando, setDesvinculando] = useState(false);

  const params = useParams();
  const fichaID = String(params.id);

  const subAbas = SubAbasFornecedores(fichaID);
  const generoOptions = useGeneros();
  const cargoOptions = useCargoFuncao();

  const [showModal, setShowModal] = useState<boolean>(false);
  const [representanteId] = useState<string>('');
  const [updating] = useState<boolean>(false);
  const [logData, setLogData] = useState<LogData>();
  const [data, setData] = useState<any[]>([]);

  const [formRepresentante, setFormRepresentante] = useState({
    generoSexual: 0,
    cargoFuncao: 0,
    cpf: '',
    nomeCompleto: '',
    dataNascimento: '',
    telefone: '',
    celular: '',
    email: '',
    linkedin: '',
    observacoes: '',

    usuarioRegistroId: userID,

    fornecedorId: parseInt(fichaID, 10),
  });

  const [formFornecedor, setFormFornecedor] = useState({
    fornecedorId: 0,
    cnpj: '',
    razaoSocial: '',
    ip: '',
  });

  //Filtro
  const [formFiltros, setFormFiltros] = useState({
    cargoFuncao: 0,
    nomeCompleto: '',
    celular: '',
    email: '',
  });

  let tituloModal = '';
  if (updating) {
    tituloModal = 'Atualizar Registro';
  } else {
    tituloModal = 'Novo Registro';
  }
  const iconeModal = 'warehouse';

  // Buscar dados
  const fetchData = async (id: string) => {
    try {
      const representantesData = await getRepresentantesByFornecedor(id);
      const fornecedorData = await getFornecedor(id);
      setData(representantesData);
      setFormRepresentante({
        generoSexual: representantesData.generoSexual,
        cargoFuncao: representantesData.cargoFuncao,
        cpf: representantesData.cpf,
        nomeCompleto: representantesData.nomeCompleto,
        dataNascimento: representantesData.dataNascimento,
        telefone: representantesData.telefone,
        celular: representantesData.celular,
        email: representantesData.email,
        linkedin: representantesData.linkedin,
        observacoes: representantesData.observacoes,

        usuarioRegistroId: userID,

        fornecedorId: parseInt(fichaID, 10),
      });
      setFormFornecedor({
        fornecedorId: fornecedorData.id,
        cnpj: fornecedorData.cnpj,
        razaoSocial: fornecedorData.razaoSocial,
        ip: fornecedorData.ip || '',
      });
      setLogData({
        id: representantesData.id,
        usuarioRegistro: representantesData.usuarioRegistro?.nomeCompleto || '',
        usuarioAtualizacao:
          representantesData.usuarioAtualizacao?.nomeCompleto || '',
        dataRegistro: representantesData.dataRegistro,
        dataAtualizacao: representantesData.dataUltimaAtualizacao,
        nEdicoes: representantesData.nEdicoes,
      });
    } catch (error) {
      console.error('Erro ao obter dados:', error);
    }
  };
  useEffect(() => {
    fetchData(fichaID);
  }, []);

  const offCanvasData = data.map((item) => ({
    id: item.id,
    dataRegistro:
      formatDate(item.dataRegistro) +
      ' - ' +
      formataNomeMeioSiglas(item.usuarioRegistro.nomeCompleto),
    dataUltimaAtualizacao:
      formatDate(item.dataUltimaAtualizacao) +
      ' - ' +
      formataNomeMeioSiglas(item.usuarioAtualizacao.nomeCompleto),
    dataUltimaVisualizacao:
      formatDate(item.dataUltimaVisualizacao) +
      ' - ' +
      formataNomeMeioSiglas(item.usuarioUltimaVisualizacao.nomeCompleto),
    nEdicoes: item.nEdicoes,
    nVisualizacoes: item.nVisualizacoes,
    cpf: item.cpf,
    nomeCompleto: item.nomeCompleto,
    cargoFuncao: cargoOptions[item.cargoFuncao].label,
    dataNascimento: item.dataNascimento,
    generoSexual: generoOptions[item.generoSexual].label,
    celular: item.celular,
    telefone: item.telefone,
    email: item.email,
    linkedin: item.linkedin,
    observacoes: item.observacoes,
  }));

  const exportData = data.map((item) => ({
    id: item.id,
    nomeCompleto: item.nomeCompleto,
    cpf: item.cpf,
    cargoFuncao: cargoOptions[item.cargoFuncao].label,
    dataNascimento: item.dataNascimento,
    generoSexual: generoOptions[item.generoSexual].label,
    celular: item.celular,
    telefone: item.telefone,
    email: item.email,
    linkedin: item.linkedin,
    observacoes: item.observacoes,

    //Dados do Fornecedor
    fornecedorId: formFornecedor.fornecedorId,
    cnpj: formFornecedor.cnpj,
    razaoSocial: formFornecedor.razaoSocial,

    //Logs
    dataRegistro: item.dataRegistro,
    dataUltimaAtualizacao: item.dataUltimaAtualizacao,
    dataUltimaVisualizacao: item.dataUltimaVisualizacao,
    usuarioRegistro: formataNomeMeioSiglas(item.usuarioRegistro.nomeCompleto),
    usuarioAtualizacao: formataNomeMeioSiglas(
      item.usuarioAtualizacao.nomeCompleto,
    ),
    usuarioUltimaVisualizacao: formataNomeMeioSiglas(
      item.usuarioUltimaVisualizacao.nomeCompleto,
    ),
    nEdicoes: item.nEdicoes,
    nVisualizacoes: item.nVisualizacoes,
  }));

  // Validação CPF
  const [cpfDigits, setCpfDigits] = useState<number>(0);
  const [validCpf] = useCpfValidation({ cpf: formRepresentante.cpf });

  const validaCPF = () => {
    if (cpfDigits > 0) {
      if (!validCpf) {
        swalErro('O CPF digitado não é válido. Digite novamente.');
        setFormRepresentante({ ...formRepresentante, cpf: '' });
      }
    }
  };

  // Funções Handle
  const handleChangeForm = (e: any) => {
    const { name, value } = e.target;
    const newValue = parseInt(value, 10);
    if (name === 'cargoFuncao') {
      setFormRepresentante({
        ...formRepresentante,
        cargoFuncao: newValue,
      });
    } else if (name === 'genero') {
      setFormRepresentante({
        ...formRepresentante,
        generoSexual: newValue,
      });
    } else {
      setFormRepresentante((prev) => ({ ...prev, [name]: value }));
    }
    // Conta dígitos do CPF
    if (name === 'cpf') {
      setCpfDigits(e.target.value.replace(/\D/g, '').length);
    }
  };

  const handleChangeFiltros = (e: any) => {
    const { name, value } = e.target;
    if (name === 'cargoFuncao') {
      const newValue = parseInt(value, 10);
      setFormFiltros({
        ...formFiltros,
        cargoFuncao: newValue,
      });
    } else {
      setFormFiltros((prev) => ({ ...prev, [name]: value }));
    }
  };

  const handleClearFiltros = () => {
    setFormFiltros({
      ...formFiltros,
      cargoFuncao: 0,
      nomeCompleto: '',
      celular: '',
      email: '',
    });
  };

  const handleShowModal = () => {
    setShowModal((show) => !show);
  };

  const validateForm = (form: any) => {
    const errors: string[] = [];

    if (!form.cpf) errors.push('<b>CPF</b> é obrigatório.');
    if (!form.generoSexual) errors.push('<b>Gênero</b> é obrigatório.');
    if (!form.cargoFuncao) errors.push('<b>Cargo</b> é obrigatório.');
    if (!form.nomeCompleto) errors.push('<b>Nome Completo</b> é obrigatório.');
    if (!form.dataNascimento)
      errors.push('<b>Data de Nascimento</b> é obrigatório.');
    if (!form.celular) errors.push('<b>Celular</b> é obrigatório.');
    if (!form.email) errors.push('<b>Email</b> é obrigatório.');

    if (errors.length > 0) {
      swalAttention(errors.join('<br>'));
      return false;
    }
    return true;
  };

  const handleCreate = async () => {
    try {
      const formAjustado = {
        ...formRepresentante,
        dataNascimento: new Date(formatDate(formRepresentante.dataNascimento)),
      };

      const formToSend = sanitizarForm(formAjustado);
      const isFormValid = validateForm(formToSend);
      if (!isFormValid) return;

      const jaVinculado = usuariosVinculados.some(
        (u) =>
          u.usuarioId?.cpf.replace(/\D/g, '') ===
          usuarioEncontrado?.cpf.replace(/\D/g, ''),
      );

      if (jaVinculado) {
        swalAttention('Este CPF já está vinculado ao CNPJ informado.');
        return;
      }

      await httpClient.post(`/api/fornecedorrepresentante`, formToSend);

      swalSave();
      fetchData(fichaID);
      setTimeout(() => handleShowModal(), 2500);
    } catch (error: any) {
      if (isHttpError(error)) {
        swalErro(error.response?.data.message);
      }
      console.error('Erro ao salvar registro:', error);
    }
  };

  const handleUpdate = async () => {
    try {
      const formAjustado = {
        ...formRepresentante,
        dataNascimento: new Date(formatDate(formRepresentante.dataNascimento)),
      };

      const formToSend = sanitizarForm(formAjustado);
      const isFormValid = validateForm(formToSend);
      if (!isFormValid) return;

      const response = await httpClient.patch(
        `/api/fornecedorrepresentante/${representanteId}`,
        formToSend,
      );

      swalAtualizacao('Sucesso', response.data.message);
      fetchData(response.data.registroAtualizado.fornecedor.id);
      setTimeout(() => {
        setShowModal(false);
      }, 2000);
    } catch (error: any) {
      if (isHttpError(error)) {
        swalErro(error.response?.data.message);
      }
      console.error('Erro ao atualizar dados', error);
    }
  };

  const handleDelete = async () => {
    const result = await swalDelete();

    if (result) {
      try {
        await httpClient.delete(
          `/api/fornecedorrepresentante/${representanteId}`,
        );
        swalDeleteConfirm();
        fetchData(fichaID);
        setTimeout(() => {
          setShowModal(false);
        }, 2000);
      } catch (error) {
        if (isHttpError(error)) {
          swalErro(error.response?.data.message);
        }
        console.error('Erro ao excluir registro', error);
        swalErro('Não foi possível excluir o registro. Tente novamente.');
      }
    } else {
      swalErro('A operação falhou.');
    }
  };

  const [showModalVinculoUsuario, setShowModalVinculoUsuario] =
    useState<boolean>(false);

  const [formVinculoUsuario, setFormVinculoUsuario] = useState<{
    id: string;
    tpVinculo: number;
  }>({
    id: '0',
    tpVinculo: 0,
  });

  const handleShowModalVinculoUsuario = () => {
    setShowModalVinculoUsuario((prev) => !prev);
  };

  const [cpfBusca, setCpfBusca] = useState('');

  const [usuarioEncontrado, setUsuarioEncontrado] = useState<any>(null);
  const [usuarioEncontradoId, setUsuarioEncontradoId] = useState<number | null>(
    null,
  );
  const [usuariosVinculados, setUsuariosVinculados] = useState<any[]>([]);

  const fetchUsuariosVinculados = async () => {
    try {
      const response = await httpClient.get(`/api/usuariointerface`, {
        params: {
          coFornecedor: formFornecedor.fornecedorId,

          nuInterfaceSisaf: 2,
          stRegistroAtivo: 'S',
        },
      });

      setUsuariosVinculados(response.data.relacoes || []);
    } catch (error) {
      console.error('Erro ao buscar usuários vinculados:', error);
      swalErro('Erro ao buscar usuários vinculados.');
    }
  };

  const handleBuscarUsuario = async () => {
    const buscaBruta = cpfBusca?.trim();
    if (!buscaBruta) return;

    try {
      const cpfRegex = /^\d{3}\.?\d{3}\.?\d{3}-?\d{2}$/;
      const isCpf = cpfRegex.test(buscaBruta);
      const cpfLimpo = buscaBruta.replace(/\D/g, '');

      if (!isCpf && buscaBruta.length < 2) {
        swal('warning', 'Digite pelo menos 2 caracteres para o nome.', '');
        return;
      }

      const params: Record<string, any> = isCpf
        ? { cpf: cpfLimpo }
        : { nome: buscaBruta };

      const response = await httpClient.get(`/api/users`, {
        params,
        headers: {
          Accept: 'application/json',
        },
      });

      const users: any[] = Array.isArray(response?.data?.users)
        ? response.data.users
        : [];

      const getRoles = (u: any): number[] => {
        if (Array.isArray(u?.papeisArray))
          return u.papeisArray
            .map((x: any) => Number(x))
            .filter(Number.isFinite);
        if (u?.papel != null) return [Number(u.papel)].filter(Number.isFinite);
        return [];
      };
      const isAdmin = (u: any) => getRoles(u).includes(1);

      const naoAdmins = users.filter((u) => !isAdmin(u));

      if (naoAdmins.length > 0) {
        naoAdmins.sort((a, b) =>
          String(a?.nomeCompleto || '').localeCompare(
            String(b?.nomeCompleto || ''),
            'pt-BR',
          ),
        );
        setListaUsuariosEncontrados(naoAdmins);
        setUsuarioEncontrado(naoAdmins[0]);
        setUsuarioEncontradoId(naoAdmins[0].id);
        return;
      }

      if (users.length > 0) {
        setListaUsuariosEncontrados([]);
        setUsuarioEncontrado(null);
        setUsuarioEncontradoId(null);
        swal(
          'info',
          'A busca retornou apenas administradores.',
          'Refine os filtros ou ajuste o critério.',
        );
        return;
      }

      setListaUsuariosEncontrados([]);
      setUsuarioEncontrado(null);
      setUsuarioEncontradoId(null);
      swal('error', 'Usuário não encontrado', 'Verifique o CPF ou nome.');
    } catch (error: any) {
      console.error('Erro ao buscar usuário:', error);
      const status = error?.response?.status;
      if (status === 401 || status === 403) {
        swalErro('Sua sessão expirou. Faça login novamente.');
      } else {
        swalErro(
          'Erro ao buscar usuário. Verifique os dados e tente novamente.',
        );
      }
    }
  };

  async function isUsuarioVinculadoEmOutraInterface() {
    const resp = await httpClient.get(`/api/usuariointerface`, {
      params: { coUsuario: usuarioEncontradoId, stRegistroAtivo: 'S' },
    });
    const vinculos: any[] = resp.data?.relacoes ?? [];

    const cnpjAlvo = String(fichaID).trim();

    return vinculos.some((v) => {
      const ativo = String(v.statusRegistroAtivo) === 'S';
      if (!ativo) return false;

      const ehFornecedor = v.coFornecedor != null && v.coSes == null;
      if (!ehFornecedor) return false;

      const mesmoFornecedor = String(v.coFornecedor) === cnpjAlvo;
      if (mesmoFornecedor) return false;

      return true;
    });
  }

  const handleVincularUsuario = async () => {
    if (!usuarioEncontrado) return;
    if (!validateFormVinculo()) return;

    try {
      const token =
        typeof window !== 'undefined' ? localStorage.getItem('token') : null;

      const coFornecedorStr = String(fichaID).trim();
      const tpVinculoNum = Number(formVinculoUsuario.tpVinculo);
      const coUsuarioNum = Number(usuarioEncontradoId);
      const coUsuarioVinculacaoNum = Number(userID);

      const jaVinculadoOutraInterface =
        await isUsuarioVinculadoEmOutraInterface();
      if (jaVinculadoOutraInterface) {
        swalAttention(
          'Este usuário já possui vínculo ativo em outra interface. Operação bloqueada.',
        );
        return;
      }

      if (!coFornecedorStr) {
        swalErro('Fornecedor inválido.');
        return;
      }
      if (
        !Number.isFinite(tpVinculoNum) ||
        (tpVinculoNum !== 1 && tpVinculoNum !== 2)
      ) {
        swalErro('Tipo de vínculo inválido.');
        return;
      }

      const existeRepresentanteAtivo = usuariosVinculados.some((u) => {
        const ehRT =
          u.tpVinculo === 1 || u.tpVinculo === '1' || u.tpVinculo === 'R';
        const ativo = String(u.statusRegistroAtivo) === 'S';

        return ehRT && ativo;
      });
      if (tpVinculoNum === 1 && existeRepresentanteAtivo) {
        swalAttention(
          'Já existe um Representante Técnico ativo para este CNPJ.',
        );
        return;
      }

      const baseDto = {
        coUsuario: coUsuarioNum,
        coUsuarioVinculacao: coUsuarioVinculacaoNum,
        nuInterfaceSisaf: 2,
        coFornecedor: coFornecedorStr,
        dtVinculacao: new Date().toISOString(),
        dsObservacao: 'Vínculo realizado via interface de administração.',
        stInterface: 'N',
        stRegistroAtivo: 'S',
        tpVinculo: tpVinculoNum,
      };

      const patchBody: any = {
        coUsuario: coUsuarioNum,
        coFornecedor: coFornecedorStr,
        dto: { ...baseDto },
      };

      const postBody = { ...baseDto };

      let vinculoOk = false;

      try {
        await httpClient.patch(
          `/api/usuariointerface/usuario-fornecedor-ses`,
          patchBody,
          {
            headers: {
              'Content-Type': 'application/json',
            },
          },
        );
        vinculoOk = true;
      } catch (err: any) {
        const status = err?.response?.status;
        if (status === 400 || status === 404 || status === 409) {
          const respPost = await httpClient.post(
            `/api/usuariointerface`,
            postBody,
            {
              headers: {
                'Content-Type': 'application/json',
              },
            },
          );
          vinculoOk = respPost.status === 201 || respPost.status === 200;
        } else {
          throw err;
        }
      }

      if (!vinculoOk) {
        swalErro('Não foi possível vincular o usuário.');
        return;
      }

      await httpClient.patch(`/api/users/${usuarioEncontradoId}`, {
        stRegistroAtivo: 'S',
      });

      swalAtualizacao('Sucesso', 'Usuário vinculado com sucesso!');
      setShowModalVinculoUsuario(false);
      setCpfBusca('');
      setUsuarioEncontrado(null);
      await fetchUsuariosVinculados();
    } catch (error: any) {
      console.error('Erro ao vincular usuário:', error);
      if (isHttpError(error)) {
        const msg =
          error.response?.data?.message ||
          error.message ||
          'Erro ao vincular usuário';
        swalErro(msg);
      } else {
        swalErro('Erro ao vincular usuário. Tente novamente mais tarde.');
      }
    }
  };

  const handleDesvincularUsuario = async (id: number) => {
    try {
      await httpClient.delete(`/api/usuariointerface/${id}`);
      await httpClient.patch(
        `/api/users/${usuarioVinculadoSelecionado?.usuarioId?.id}`,
        {
          stRegistroAtivo: 'N',
        },
      );

      swalAtualizacao('Sucesso', 'Usuário desvinculado com sucesso.');
      setShowModal(false);
      fetchUsuariosVinculados();
    } catch (error) {
      console.error('Erro ao desvincular usuário:', error);
      swalErro('Erro ao desvincular usuário.');
    } finally {
      setDesvinculando(false);
    }
  };

  const valoresExibidos = {
    nomeCompleto: 'Nome',
    cpf: 'CPF',
    cargoFuncao: 'Cargo',
    dataNascimento: 'Nascimento',
    generoSexual: 'Gênero',
    celular: 'Celular',
    telefone: 'Telefone',
    email: 'Email',
    linkedin: 'LinkedIn',
    observacoes: 'Observações',
    dataRegistro: 'Data Registro',
    dataUltimaAtualizacao: 'Última Atualização',
    dataUltimaVisualizacao: 'Última Visualização',
    nEdicoes: 'Nº Edições',
    nVisualizacoes: 'Nº Visualizações',
  };

  const tiposVinculo = {
    1: 'Representante Técnico',
    2: 'Usuário',
  } as const;

  const tableData = usuariosVinculados.map((item) => ({
    id: item.id,
    nome: item.usuarioId?.nomeCompleto || '---',
    cpf: formataCPF(item.usuarioId?.cpf) || '---',
    celular: item.usuarioId?.celular || '---',
    email: item.usuarioId?.emailPessoal || '---',
    dataVinculacao: formatDate(item.dataVinculacao),
    responsavelVinculacao: item.usuarioVinculacao?.nomeCompleto || '---',
    tpVinculo: tiposVinculo[item.tpVinculo as 1 | 2] || '---',
    status: (
      <Status
        label={item.statusInterface === 'S' ? 'Ativo' : 'Pendente'}
        color={
          item.statusInterface === 'S'
            ? 'rgba(9, 175, 9, 0.655)'
            : 'rgba(200, 50, 50, 0.7)'
        }
        icon={
          item.statusInterface === 'S' ? FaCheckCircle : FaExclamationTriangle
        }
      />
    ),
  }));

  useEffect(() => {
    fetchData(fichaID);
  }, [fichaID]);

  useEffect(() => {
    if (formFornecedor.cnpj) {
      fetchUsuariosVinculados();
    }
  }, [formFornecedor.cnpj]);

  const tpVinculoOptions = [
    { label: 'Selecione...', value: '' },
    { label: 'Representante Técnico', value: 1 },
    { label: 'Usuário', value: 2 },
  ];

  const validateFormVinculo = () => {
    const errors: string[] = [];

    if (
      formVinculoUsuario.tpVinculo === null ||
      formVinculoUsuario.tpVinculo === undefined ||
      formVinculoUsuario.tpVinculo === 0
    ) {
      errors.push('<b>Tipo de Vínculo</b> é obrigatório.');
    }

    if (!usuarioEncontrado) {
      errors.push('<b>Usuário</b> deve ser pesquisado e selecionado.');
    }

    if (errors.length > 0) {
      swalAttention(errors.join('<br>'));
      return false;
    }

    return true;
  };

  const handleAtualizarTpVinculo = async () => {
    try {
      if (usuarioVinculadoSelecionado.tpVinculo === 1) {
        const jaExisteOutro = usuariosVinculados.some(
          (u) =>
            u.tpVinculo === 1 &&
            u.id !== usuarioVinculadoSelecionado.id &&
            u.statusRegistroAtivo === 'S',
        );
        if (jaExisteOutro) {
          swalAttention(
            'Já existe um Representante Técnico ativo vinculado a este CNPJ.',
          );
          return;
        }
      }

      await httpClient.patch(
        `/api/usuariointerface/${usuarioVinculadoSelecionado.id}`,
        {
          tpVinculo: usuarioVinculadoSelecionado.tpVinculo,
          dsObservacao: usuarioVinculadoSelecionado.observacao,
        },
      );

      swalAtualizacao('Sucesso', 'Perfil atualizado com sucesso!');
      setShowModal(false);
      fetchUsuariosVinculados();
    } catch (error: any) {
      console.error('Erro ao atualizar tipo de vínculo:', error);
      if (isHttpError(error)) {
        const msg = error.response?.data?.message;
        if (typeof msg === 'string') {
          if (
            msg.includes('Representante Técnico ativo vinculado a este CNPJ')
          ) {
            swalAttention(msg);
            return;
          }
          if (msg.includes('já existe') && msg.toLowerCase().includes('cpf')) {
            swalAttention(msg);
            return;
          }
        }
      }
      swalErro('Erro ao atualizar o perfil do usuário vinculado.');
    }
  };

  return (
    <>
      <SubAbas>
        <StyledLink
          to="/daf/fornecedores/fornecedores"
          style={{
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'center',
            alignItems: 'center',
            cursor: 'pointer',
            backgroundColor: '#C5D4EB',
          }}
        >
          <FaArrowLeft />
        </StyledLink>
        <BarraSubAbas subAbas={subAbas} />
      </SubAbas>

      <ContainerConteudo>
        <Modal
          icone={iconeModal}
          tituloModal={tituloModal}
          open={showModal}
          onHide={handleShowModal}
        >
          <WorkspaceFicha>
            <Log {...logData} />
            <CustomRow style={{ marginTop: '10px' }}>
              <CustomCol width="15%">
                <Input
                  name="cpf"
                  mascara="cpf"
                  value={formRepresentante.cpf}
                  id="cpf"
                  label="CPF"
                  onChange={handleChangeForm}
                  onBlur={validaCPF}
                  required
                />
              </CustomCol>
              <CustomCol width="45%">
                <Input
                  name="nomeCompleto"
                  value={formRepresentante.nomeCompleto}
                  id="nome"
                  label="Nome Completo"
                  onChange={handleChangeForm}
                  required
                />
              </CustomCol>
              <CustomCol width="20%">
                <Input
                  name="dataNascimento"
                  type="date"
                  value={formRepresentante.dataNascimento}
                  id="dataNascimento"
                  label="Data de Nascimento"
                  onChange={handleChangeForm}
                />
              </CustomCol>
              <CustomCol width="20%">
                <Select
                  name="cargoFuncao"
                  value={formRepresentante.cargoFuncao}
                  options={cargoOptions}
                  onChange={handleChangeForm}
                  label="Cargo"
                />
              </CustomCol>
            </CustomRow>
            <CustomRow>
              <CustomCol width="15%">
                <Select
                  name="genero"
                  value={formRepresentante.generoSexual}
                  options={generoOptions}
                  onChange={handleChangeForm}
                  label="Gênero"
                />
              </CustomCol>
              <CustomCol width="15%">
                <Input
                  name="telefone"
                  value={formRepresentante.telefone}
                  id="celular"
                  mascara="celular"
                  label="Telefone"
                  onChange={handleChangeForm}
                />
              </CustomCol>
              <CustomCol width="15%">
                <Input
                  name="celular"
                  value={formRepresentante.celular}
                  id="celular"
                  mascara="celular"
                  label="Celular"
                  onChange={handleChangeForm}
                  required
                />
              </CustomCol>
              <CustomCol width="30%">
                <Input
                  name="email"
                  value={formRepresentante.email}
                  id="email"
                  label="Email"
                  onChange={handleChangeForm}
                  required
                />
              </CustomCol>
              <CustomCol width="25%">
                <Input
                  name="linkedin"
                  value={formRepresentante.linkedin}
                  id="linkedin"
                  label="LinkedIn"
                  onChange={handleChangeForm}
                  required
                />
              </CustomCol>
            </CustomRow>
            <CustomRow>
              <Col>
                <Input
                  id="observacoes"
                  type="textarea"
                  name="observacoes"
                  value={formRepresentante.observacoes}
                  label="Observações"
                  onChange={handleChangeForm}
                />
              </Col>
            </CustomRow>
            <BarraInferiorBotoes>
              {updating ? (
                <WorkspaceBotoes
                  delete
                  onClickDelete={handleDelete}
                  save
                  onClickSave={handleUpdate}
                />
              ) : (
                <WorkspaceBotoes inserir onClickInserir={handleCreate} />
              )}
            </BarraInferiorBotoes>
          </WorkspaceFicha>
        </Modal>

        <BoxConteudo boxTitulo="Filtros" fechado>
          <CustomRow style={{ marginTop: '-15px' }}>
            <CustomCol width="15%">
              <Select
                name="cargoFuncao"
                value={formFiltros.cargoFuncao}
                options={cargoOptions}
                onChange={handleChangeFiltros}
                label="Cargo"
              />
            </CustomCol>
            <CustomCol width="40%">
              <Input
                id="nomeCompleto"
                name="nomeCompleto"
                value={formFiltros.nomeCompleto}
                label="Nome"
                onChange={handleChangeFiltros}
              />
            </CustomCol>
            <CustomCol width="20%">
              <Input
                id="celular"
                name="celular"
                value={formFiltros.celular}
                label="Celular"
                onChange={handleChangeFiltros}
              />
            </CustomCol>
            <CustomCol width="25%">
              <Input
                id="email"
                name="email"
                value={formFiltros.email}
                label="email"
                onChange={handleChangeFiltros}
              />
            </CustomCol>
          </CustomRow>
          <CustomRow style={{ marginTop: '-15px', textAlign: 'right' }}>
            <CustomCol className="mt-3 justify-content-end align-content-end">
              <CustomButton
                label="Limpar filtros"
                bgColor="#808080"
                textColor="#ffffff"
                onClick={handleClearFiltros}
              />
            </CustomCol>
          </CustomRow>
        </BoxConteudo>

        <Tabela
          headers={headersUsuariosVinculados}
          dataTable={tableData}
          dataOffCanvas={offCanvasData}
          displayValues={valoresExibidos}
          rowClickable={true}
          onRowClick={handleRowClickUsuarioVinculado}
        />
      </ContainerConteudo>

      <BarraInferiorBotoes>
        <WorkspaceBotoes
          download
          onClickDownload={() =>
            ExportToExcel(
              exportData,
              valoresExibidos,
              fieldObject,
              'sisaf_fornecedores_representantes.xlsx',
              userID,
              'DAF',
              entity,
            )
          }
          inserir
          onClickInserir={handleShowModalVinculoUsuario}
        />
      </BarraInferiorBotoes>

      <Modal
        tituloModal="Detalhes do Usuário Vinculado"
        open={showDetalhesUsuario && !!usuarioVinculadoSelecionado}
        onHide={() => {
          setShowDetalhesUsuario(false);
          setUsuarioVinculadoSelecionado(null);
        }}
      >
        <WorkspaceFicha>
          {usuarioVinculadoSelecionado && (
            <>
              <Log
                dataRegistro={usuarioVinculadoSelecionado.dataVinculacao}
                usuarioRegistro={
                  usuarioVinculadoSelecionado.usuarioVinculacao?.nomeCompleto ||
                  '---'
                }
              />

              <CustomRow>
                <CustomCol width="15%">
                  <Input
                    id="status-vinculacao"
                    label="Status"
                    value={
                      usuarioVinculadoSelecionado.statusInterface === 'S'
                        ? 'Ativo'
                        : 'Pendente'
                    }
                    readonly
                    onChange={(e) => void e}
                    style={{
                      backgroundColor:
                        usuarioVinculadoSelecionado.statusInterface === 'S'
                          ? '#abf3aba7'
                          : '#ffcecec3',
                    }}
                  />
                </CustomCol>
                <CustomCol width="15%">
                  <Input
                    id="cpf-usuario-vinculado"
                    label="CPF"
                    mascara="cpf"
                    value={usuarioVinculadoSelecionado.usuarioId?.cpf || '---'}
                    readonly
                    onChange={(e) => void e}
                  />
                </CustomCol>
                <CustomCol width="70%">
                  <Input
                    id="nome-usuario-vinculado"
                    label="Nome Completo"
                    value={
                      usuarioVinculadoSelecionado.usuarioId?.nomeCompleto ||
                      '---'
                    }
                    readonly
                    onChange={(e) => void e}
                  />
                </CustomCol>
              </CustomRow>

              <CustomRow>
                <CustomCol width="15%">
                  <Input
                    id="data-vinculacao"
                    label="Data de Vinculação"
                    value={formatDate(
                      usuarioVinculadoSelecionado.dataVinculacao,
                    )}
                    readonly
                    onChange={(e) => void e}
                  />
                </CustomCol>
                <CustomCol width="15%">
                  <Input
                    id="celular-usuario-vinculado"
                    label="Celular"
                    value={
                      usuarioVinculadoSelecionado.usuarioId?.celular || '---'
                    }
                    readonly
                    onChange={(e) => void e}
                  />
                </CustomCol>
                <CustomCol width="70%">
                  <Input
                    id="email-usuario-vinculado"
                    label="Email"
                    value={
                      usuarioVinculadoSelecionado.usuarioId?.emailPessoal ||
                      '---'
                    }
                    readonly
                    onChange={(e) => void e}
                  />
                </CustomCol>
              </CustomRow>
              <CustomRow>
                <Col>
                  <Input
                    id="observacoes-vinculacao"
                    label="Observações"
                    type="textarea"
                    value={usuarioVinculadoSelecionado?.observacao ?? ''}
                    onChange={(e) =>
                      setUsuarioVinculadoSelecionado((prev: any) =>
                        prev ? { ...prev, observacao: e.target.value } : prev,
                      )
                    }
                  />
                </Col>
              </CustomRow>
              <CustomRow>
                <CustomCol width="50%">
                  <Select
                    name="tpVinculo"
                    value={usuarioVinculadoSelecionado?.tpVinculo || ''}
                    options={tpVinculoOptions}
                    label="Perfil"
                    onChange={(e) => {
                      const novoTp = parseInt(e.target.value, 10);
                      setUsuarioVinculadoSelecionado((prev: any) => ({
                        ...prev,
                        tpVinculo: novoTp,
                      }));
                    }}
                  />
                </CustomCol>
              </CustomRow>
              <BarraInferiorBotoes>
                <WorkspaceBotoesNew
                  label="Desvincular"
                  tipo="cancel"
                  icone={<FaTrash />}
                  onClick={() =>
                    handleDesvincularUsuario(usuarioVinculadoSelecionado.id)
                  }
                  style={{ marginRight: '8px' }}
                />
                <WorkspaceBotoesNew
                  label="Salvar Alteração"
                  tipo="save"
                  onClick={handleAtualizarTpVinculo}
                />
              </BarraInferiorBotoes>
            </>
          )}
        </WorkspaceFicha>
      </Modal>

      <Modal
        tituloModal="Vincular Novo Usuário"
        open={showModalVinculoUsuario}
        onHide={handleShowModalVinculoUsuario}
      >
        <WorkspaceFicha>
          <CustomRow className="mb-4" style={{ alignItems: 'flex-end' }}>
            <CustomCol width="30%" style={{ display: 'flex', gap: '8px' }}>
              <Input
                name="buscaUsuario"
                value={cpfBusca}
                id="buscaUsuario"
                label="Buscar por CPF ou Nome"
                onChange={(e) => setCpfBusca(e.target.value)}
                required
              />

              <CustomButton
                label="Pesquisar"
                bgColor={theme.colors.botaoAcao.azul}
                textColor={theme.colors.white}
                onClick={handleBuscarUsuario}
                style={{ marginTop: '28px' }}
              />
            </CustomCol>
          </CustomRow>

          <CustomRow>
            <CustomCol width="20%">
              <Select
                name="tpVinculo"
                value={formVinculoUsuario.tpVinculo}
                options={tpVinculoOptions}
                label="Tipo de Vínculo"
                onChange={(e) =>
                  setFormVinculoUsuario({
                    ...formVinculoUsuario,
                    tpVinculo: parseInt(e.target.value, 10),
                  })
                }
                required
              />
            </CustomCol>

            <CustomCol width="80%">
              {listaUsuariosEncontrados.length <= 1 ? (
                <Input
                  name="nome"
                  value={usuarioEncontrado?.nomeCompleto || ''}
                  id="nome"
                  label="Nome"
                  readonly
                  onChange={(e) => void e}
                  required
                />
              ) : (
                <Select
                  name="usuarioSelecionado"
                  value={usuarioSelecionadoId || ''}
                  label="Selecione o usuário encontrado"
                  options={listaUsuariosEncontrados.map((u) => ({
                    label: `${u.nomeCompleto} - ${formataCPF(u.cpf)}`,
                    value: u.id,
                  }))}
                  onChange={(e) => {
                    const selectedId = parseInt(e.target.value, 10);
                    const selectedUser = listaUsuariosEncontrados.find(
                      (u) => u.id === selectedId,
                    );
                    setUsuarioSelecionadoId(selectedId);
                    setUsuarioEncontrado(selectedUser || null);
                    setUsuarioEncontradoId(selectedUser?.id || null);
                  }}
                  required
                />
              )}
            </CustomCol>
          </CustomRow>

          <CustomRow>
            <CustomCol style={{ textAlign: 'right' }}>
              <CustomButton
                label="Vincular Usuário"
                bgColor={theme.colors.botaoAcao.azul}
                textColor={theme.colors.white}
                onClick={handleVincularUsuario}
                disabled={!usuarioEncontrado}
              />
            </CustomCol>
          </CustomRow>

          <BarraInferiorBotoes />
        </WorkspaceFicha>
      </Modal>
    </>
  );
}

export default FornecedoresPRIndex;
